export enum IPoliticalRegimeActionTypes {
  GET_POLITICAL_REGIME = "@@politicalRegin/GET_POLITICAL_REGIME",
  GET_POLITICAL_REGIME_SUCCESS = "@@politicalRegin/GET_POLITICAL_REGIME_SUCCESS",
  GET_POLITICAL_REGIME_FAILURE = "@@politicalRegin/GET_POLITICAL_REGIME_FAILURE",
}

export interface IPoliticalRegimeState {
  results: IPoliticalRegime[];
  isLoading: boolean;
  isError: boolean;
  errorMessage: string;
}

export interface IPoliticalRegime {
  color: number;
  id: number;
  index: string;
  name: string;
  cumuls: ICumul;
  political_group_ids: IPoliticalGroupId;
  political_regime_id: number;
  political_regime_name: string;
}

export interface ICumul {
  days: IPeriod;
  month: IPeriod;
  quarter: IPeriod;
  semester: IPeriod;
  year: IPeriod;
}

export interface IPeriod {
  [period: string]: IPeriodSimple;
}

export interface IPeriodSimple {
  display_hms: string;
  libelle_row: string;
  milliseconds: number;
  percent: string;
  percent_base100: string;
}

export interface IPoliticalGroupId {
  readonly [politicalGroupId: string]: IPoliticalGroupSimple;
}

export interface IPoliticalGroupSimple {
  cumuls: ICumul;
  political_group_id: number;
  political_group_name: string;
}
